<app-loader *ngIf="loader"></app-loader>
<section class="profile_section">
  <nav class="navbar navbar-expand-lg navbar-light transparent mt-2">
    <div class="col-12 p-0 d-flex align-items-center justify-content-between">
      <a routerLink="/bot-info">
        <img src="../../../assets/img/redback.png" alt="back" /><span
          class="title_get ml-2"
          >Back</span
        ></a
      >
      <span class="font-weight-bold text-dark">Bot Info</span>
      <a class="title_get">EDIT</a>
    </div>
  </nav>

  <div class="container-fluid p-0 edit__container">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row top__row">
              <div class="col-6">
                <a routerLink="/bot-info" class="title_get">Cancel</a>
              </div>
              <div class="col-6 d-flex justify-content-end">
                <a
                  class="title_get"
                  style="cursor: pointer"
                  (click)="saveDetails()"
                  >Done</a
                >
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12">
                <p class="font-weight-bold">Utility details</p>
              </div>
            </div>

            <form>
              <div class="row profile__edit mt-3">
                <div class="col-4">Utility Name</div>
                <div
                  class="col-8 d-flex justify-content-end align-items-center"
                >
                  <!-- <input
                      type="text"
                      [(ngModel)]="utility.utilityName"
                      name="address"
                      autofocus
                    /> -->
                  <div class="form-group">
                    <!-- <span class="font-weight-bold">Device 01 </span> -->
                    <select
                      id="exampleFormControlSelect1"
                      style="width: 100%"
                      autofocus
                      [(ngModel)]="utility.utilityName"
                      (ngModelChange)="onUtilityChange($event)"
                      name="utilityName"
                    >
                      <option
                        *ngFor="let utility of utilityByPincode"
                        value="{{ utility.name }}"
                      >
                        {{ utility.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row profile__edit mt-3">
                <div class="col-4">Consumer ID</div>
                <div
                  class="col-8 d-flex justify-content-end align-items-center"
                >
                  <input
                    type="text"
                    [(ngModel)]="utility.consumerId"
                    name="consumerId"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
